var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zj-layout-container',[_c('zj-layout-main',[_c('div',{ref:"container",staticClass:"zj-layout-main-content bgcolor scrollable"},[_vm._v(" 烟囱监测 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }